"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const theme_1 = require("../../../theme");
const Paper = (props) => {
    const { backgroundDark = true, square = false, border, level = 1, sx = {}, ...rest } = props;
    let borderRadius = 0;
    if (!square) {
        if (level === 1) {
            borderRadius = ["0.6rem", "1.2rem"];
        }
        else {
            borderRadius = ["0.3rem", "0.6rem", "1rem"];
        }
    }
    return (react_1.default.createElement(material_1.Paper, { square: square, elevation: 0, sx: {
            backgroundColor: backgroundDark ? theme_1.colors.secondary[700] : theme_1.colors.secondary[600],
            borderRadius,
            border: border ? `1px solid ${theme_1.colors.secondary[600]}` : 0,
            p: {
                xs: level > 1 ? "1rem" : "0.8rem",
                sm: "1.4rem",
            },
            ...sx,
        }, ...rest }));
};
exports.default = Paper;
